import { AnimatePresence, motion } from "motion/react";
import { CHAPTERS } from "./chapters";
import { slides } from "./registry";

interface OverviewProps {
  open: boolean;
  currentIndex: number;
  onSelect: (index: number) => void;
}

export function Overview({ open, currentIndex, onSelect }: OverviewProps) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="absolute inset-0 z-40 overflow-y-auto bg-ink-950/85 px-16 py-12 backdrop-blur-2xl"
        >
          <p className="mb-10 text-xl uppercase tracking-widest text-white/40">
            Overview — click a slide, or press Esc to return
          </p>
          {CHAPTERS.map((chapter) => {
            const chapterSlides = slides
              .map((s, i) => ({ slide: s, index: i }))
              .filter(({ slide }) => slide.chapter === chapter.number);
            if (chapterSlides.length === 0) return null;
            return (
              <section key={chapter.number} className="mb-10">
                <h2 className="mb-4 font-display text-2xl font-semibold">
                  <span
                    className="bg-clip-text text-transparent"
                    style={{
                      backgroundImage: `linear-gradient(90deg, ${chapter.accent[0]}, ${chapter.accent[1]})`,
                    }}
                  >
                    {String(chapter.number).padStart(2, "0")} · {chapter.title}
                  </span>
                </h2>
                <div className="grid grid-cols-4 gap-4">
                  {chapterSlides.map(({ slide, index }, j) => (
                    <motion.button
                      key={slide.id}
                      type="button"
                      onClick={() => onSelect(index)}
                      initial={{ opacity: 0, y: 16 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.05 + j * 0.04, duration: 0.35 }}
                      className={`glass relative overflow-hidden p-5 text-left transition hover:bg-white/10 ${
                        index === currentIndex ? "ring-2 ring-white/40" : ""
                      }`}
                    >
                      <span
                        className="absolute inset-y-0 left-0 w-1"
                        style={{
                          background: `linear-gradient(180deg, ${chapter.accent[0]}, ${chapter.accent[1]})`,
                        }}
                      />
                      <span className="block font-mono text-xl text-white/40">
                        {index + 1}
                      </span>
                      <span className="mt-1 block text-xl font-medium text-white/90">
                        {slide.title}
                      </span>
                    </motion.button>
                  ))}
                </div>
              </section>
            );
          })}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
